import LegalPageEditor from './LegalPageEditor'

const SECTIONS = [
    { id: 'privacy-policy', label: 'Privacy Policy' },
    { id: 'cookie-policy', label: 'Cookie Policy' },
    { id: 'dpa', label: 'Data Processing Agreement (DPA)' },
    { id: 'security', label: 'Security Statement' },
]

export default function PrivacyCmsPage() {
    return (
        <LegalPageEditor
            page="privacy"
            liveUrl={`${import.meta.env.VITE_FRONTEND_URL || 'https://tendercentrix.com'}/privacy`}
            pageTitle="Privacy & Data Security — Content Editor"
            pageDescription="Edit the hero and all privacy/data sections. Content is stored as HTML."
            sections={SECTIONS}
        />
    )
}
